<c-card *transloco="let t">
    <c-card-body class="px-2">

      <app-worker-reports-menu></app-worker-reports-menu>

        <div class="row">
          <div class="col-sm-8">
            <h3>{{ t('Report: Escalation List') }}</h3>
            <p> {{ t('List of all the workers in your account and their escalation procedures.') }}</p>
          </div>
          <div class="col-sm-4 text-end">

            <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
              <i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}
            </button>
          </div>
        </div>

          <c-row *ngIf="workers">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ t('PIN') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Escalation Procedure') }}</th>
                    <!-- <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th> -->
                    <!-- <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col">{{ t('Groups') }}</th> -->
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let worker of workers" [ngClass]="{'table-success': worker.type === 'company', 'table-warning': worker.type === 'group', 'table-info': worker.type === 'worker' }">
                        <th scope="row">
                            <span class="badge bg-light text-dark">{{worker.pin}}</span>
                        </th>
                      <td>
                        <span><b>{{worker.name}}</b></span>
                      </td>
                      <td>
                        {{worker.escalation}}
                      </td>
                      <!-- <td>
                        {{worker.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                        </div>
                      </td> -->
                      <!-- <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.monitors}}</span>
                        </div>
                      </th>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.groups}}</span>
                        </div>
                      </th> -->

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

    </c-card-body>
  </c-card>
